(function () {
  if (window.__inventoryAvailabilityInitialized) return;
  window.__inventoryAvailabilityInitialized = true;

  function variantHasInventory(variant) {
    if (!variant || typeof variant !== 'object') return false;

    var tracksInventory = variant.inventory_management !== null &&
      typeof variant.inventory_management !== 'undefined' &&
      variant.inventory_management !== '';

    if (!tracksInventory) return Boolean(variant.available);

    var quantity = Number(variant.inventory_quantity);
    return Number.isFinite(quantity) ? quantity > 0 : Boolean(variant.available);
  }

  function normalizeProduct(product) {
    if (!product || !Array.isArray(product.variants)) return product;

    product.variants.forEach(function (variant) {
      variant.available = variantHasInventory(variant);
    });

    product.available = product.variants.some(function (variant) {
      return Boolean(variant.available);
    });

    return product;
  }

  function normalizePayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;

    if (payload.product) {
      normalizeProduct(payload.product);
    } else {
      normalizeProduct(payload);
    }

    return payload;
  }

  function isProductCacheValue(value) {
    if (typeof value !== 'string' || value.charAt(0) !== '{') return false;

    try {
      var payload = JSON.parse(value);
      var product = payload && (payload.product || payload);
      return Boolean(product && product.handle && Array.isArray(product.variants));
    } catch (error) {
      return false;
    }
  }

  function preventStaleProductCache() {
    if (!window.sessionStorage || !window.Storage) return;

    var nativeGetItem = Storage.prototype.getItem;
    var nativeSetItem = Storage.prototype.setItem;
    var nativeRemoveItem = Storage.prototype.removeItem;
    var productCache = {};

    Storage.prototype.getItem = function (key) {
      var value = nativeGetItem.call(this, key);

      if (this !== window.sessionStorage) return value;

      if (Object.prototype.hasOwnProperty.call(productCache, key)) {
        return productCache[key];
      }

      if (isProductCacheValue(value)) {
        nativeRemoveItem.call(this, key);
        return null;
      }

      return value;
    };

    Storage.prototype.setItem = function (key, value) {
      if (this === window.sessionStorage && isProductCacheValue(value)) {
        productCache[key] = value;
        nativeRemoveItem.call(this, key);
        return;
      }

      return nativeSetItem.call(this, key, value);
    };

    Storage.prototype.removeItem = function (key) {
      if (this === window.sessionStorage) {
        delete productCache[key];
      }

      return nativeRemoveItem.call(this, key);
    };
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isProductJsonRequest(input) {
    var rawUrl = requestUrl(input);
    if (!rawUrl) return false;

    try {
      var url = new URL(rawUrl, window.location.origin);
      var isSameOrigin = url.origin === window.location.origin;
      var isProductPath = /^\/products\/[^/?#]+(?:\.json)?$/.test(url.pathname);
      var isJsonView = url.searchParams.get('view') === 'json';
      var isJsonEndpoint = url.pathname.slice(-5) === '.json';

      return isSameOrigin && isProductPath && (isJsonView || isJsonEndpoint);
    } catch (error) {
      return false;
    }
  }

  function normalizeProductResponses() {
    if (!window.fetch) return;

    var nativeFetch = window.fetch;

    window.fetch = function () {
      var input = arguments[0];

      return nativeFetch.apply(this, arguments).then(function (response) {
        if (!isProductJsonRequest(input) || !response || !response.clone) {
          return response;
        }

        return response.clone().json().then(function (payload) {
          var headers = new Headers(response.headers);

          if (!headers.has('content-type')) {
            headers.set('content-type', 'application/json');
          }

          return new Response(JSON.stringify(normalizePayload(payload)), {
            status: response.status,
            statusText: response.statusText,
            headers: headers
          });
        }).catch(function () {
          return response;
        });
      });
    };
  }

  function patchThemeComponents() {
    if (!window.customElements || !customElements.define) return;

    var nativeDefine = customElements.define.bind(customElements);

    customElements.define = function (name, constructor, options) {
      if (name === 'variant-selector') {
        patchVariantSelector(constructor);
      }

      if (name === 'component-addtocart') {
        patchAddToCartComponent(constructor);
      }

      if (name === 'component-swatches') {
        patchSwatchesComponent(constructor);
      }

      if (name === 'product-card') {
        patchProductCard(constructor);
      }

      return nativeDefine(name, constructor, options);
    };
  }

  function patchVariantSelector(constructor) {
    var originalRender = constructor.prototype.render;
    var originalInitEvents = constructor.prototype.initEvents;

    constructor.prototype.render = function (product) {
      normalizeProduct(product);
      return originalRender.call(this, product);
    };

    constructor.prototype.initEvents = function (product) {
      var select = this.querySelector('select');
      var selectedOption = select && getSelectedVariantOption(select);
      var firstAvailableOption = select && select.querySelector('option[data-enabled]');

      if (selectedOption) {
        select.value = selectedOption.value;
      } else if (firstAvailableOption) {
        select.value = firstAvailableOption.value;
      }

      return originalInitEvents.call(this, product);
    };
  }

  function getSelectedVariantOption(select) {
    var selectedVariantId = null;

    try {
      selectedVariantId = new URL(window.location.href).searchParams.get('variant');
    } catch (error) {
      selectedVariantId = null;
    }

    if (!selectedVariantId) return null;

    return Array.prototype.slice.call(select.querySelectorAll('option')).find(function (option) {
      return String(option.value) === String(selectedVariantId);
    }) || null;
  }

  function patchAddToCartComponent(constructor) {
    var originalInitEvents = constructor.prototype.initEvents;
    var originalHandleVariantStockState = constructor.prototype.handleVariantStockState;

    constructor.prototype.initEvents = function (product) {
      normalizeProduct(product);
      return originalInitEvents.call(this, product);
    };

    constructor.prototype.handleVariantStockState = function (variant, initialLoad) {
      if (variant) variant.available = variantHasInventory(variant);
      return originalHandleVariantStockState.call(this, variant, initialLoad);
    };
  }

  function patchSwatchesComponent(constructor) {
    var originalRender = constructor.prototype.render;

    constructor.prototype.render = function (product) {
      normalizeProduct(product);
      return originalRender.call(this, product);
    };

    constructor.prototype.getVariantSelector = function () {
      var wrapper = this.closest('component-addtocart') || this.parentElement || document;
      var selector = 'variant-selector[data-handle="' + this.dataset.handle + '"] select';
      return wrapper.querySelector(selector) || document.querySelector(selector);
    };

    constructor.prototype.selectFirstVariantAvailable = function (product) {
      var selector = this.getVariantSelector();
      var firstAvailableOption = selector && selector.querySelector('option[data-enabled]');

      if (!firstAvailableOption) return;

      var variant = product.variants.find(function (item) {
        return String(item.id) === String(firstAvailableOption.dataset.variantId);
      });

      this.selectVariant(variant);
    };
  }

  function patchProductCard(constructor) {
    var originalRender = constructor.prototype.render;

    constructor.prototype.render = function (product) {
      normalizeProduct(product);
      return originalRender.call(this, product);
    };
  }

  preventStaleProductCache();
  normalizeProductResponses();
  patchThemeComponents();
}());
